import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputBox from '../../../atomic/inputbox/InputBox';
import { getStatusMenuProps, sharedInputSx } from './restaurantDeliveryConstants';
import { STATUS_TABS } from './restaurantDeliveryConfig';

function statusOptionLabel(opt) {
  return opt.value === 'all' ? 'All orders' : opt.label;
}

function StatusMenuItem({ opt, count }) {
  return (
    <Box
      component='span'
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        gap: 1,
      }}
    >
      <span>{statusOptionLabel(opt)}</span>
      <Box component='span' sx={{ fontWeight: 700, fontSize: 12, color: '#3F3F6E', flexShrink: 0 }}>
        {count}
      </Box>
    </Box>
  );
}

const statusSelectSx = {
  minWidth: 0,
  flex: '0 1 200px',
  ...sharedInputSx,
  '& .MuiSelect-select': {
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
  },
};

export function OrdersPanelFilterRow({
  statusFilter,
  onStatusFilterChange,
  statusTabCounts,
  orderIdSearch,
  onOrderIdSearchChange,
}) {
  return (
    <div className='otd-panel__filters-row'>
      <FormControl size='small' sx={statusSelectSx}>
        <InputLabel id='otd-panel-status-label'>Status</InputLabel>
        <Select
          labelId='otd-panel-status-label'
          id='otd-panel-status'
          value={statusFilter}
          label='Status'
          onChange={(e) => onStatusFilterChange(e.target.value)}
          MenuProps={getStatusMenuProps(false)}
          renderValue={(value) => {
            const opt = STATUS_TABS.find((t) => t.value === value) ?? STATUS_TABS[0];
            const count = statusTabCounts?.[opt.value] ?? 0;
            return `${statusOptionLabel(opt)} (${count})`;
          }}
        >
          {STATUS_TABS.map((opt) => (
            <MenuItem key={opt.value} value={opt.value}>
              <StatusMenuItem opt={opt} count={statusTabCounts?.[opt.value] ?? 0} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <InputBox
        type='text'
        label='Search orders'
        size='small'
        height='auto'
        name='orderIdSearch'
        value={orderIdSearch}
        onChange={(e) => onOrderIdSearchChange(e.target.value)}
        sx={{
          flex: '1 1 120px',
          minWidth: 0,
          ...sharedInputSx,
        }}
      />
    </div>
  );
}
